import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import {calculators}  from '../../common/js/calculator';
import ppfCalculator from '../ppfCalculator/ppfCalculator';
const suitability = {
    variables :{
        suitabilityNextButton : '.suitability__buttons--next',
        suitabilityPrevButton : '.suitability__buttons--prev',
        suitabilityFormSubmit : '.suitability__forms',
        suitabilityAnwers: '.suitability__wrapper--answers',
        suitabilityAmountRupee:'.chli__calculator--label',
        suitabilityTextPlaceholder: '{amount}',
        suitabilityTextAmountInput:'.suitability--input',
        suitabilityTextAmountDetails:'.suitability__input-div',
        suitabilityTextAnswersButton:'.suitability__answer-buttons--prev',
        suitabilityDetails:'.suitability__forms--details-1',
        suitabilityStep : '.suitability__wrapper--step',
        suitabilityAnswersWrap:'.suitability__graph-details--details',
        suitabilitygreetingText : '.suitability__answers-greeting',
        suitabilityAnswersMoney:'.suitability__answers-money',
        suitabilityAnswerMessage: '.suitability__answers-message',
        suitabilityInvestTime : '.suitability__answers-investment',
        suitabilityCorpusCreated:'.suitability__corpus-created',
        suitabilityMobileSteps:'.suitability__wrapper--mobile-steps'
    },
    methods : {
        replaceAmountInput : (el)=>{
            const $el = $(el);
            const {suitabilityTextPlaceholder,suitabilityTextAmountInput,suitabilityAmountRupee} = suitability.variables;
            let termInsuranePlaceholderText = suitabilityTextPlaceholder;
            if($el.hasClass('investment-goal')){
                termInsuranePlaceholderText = '{goal}';
            } else if($el.hasClass('suitability-risk')){
                termInsuranePlaceholderText = '{level}';
            } else if($el.hasClass('numberOfPolicies')){
                termInsuranePlaceholderText = '{polices}';
            }  else if($el.hasClass('income-text')){
                termInsuranePlaceholderText = '{income}';
            }  else if($el.hasClass('name')){
                termInsuranePlaceholderText = '{name}';
            } else if($el.hasClass('contact')){
                termInsuranePlaceholderText = '{mobile}';
            }
            if($el.hasClass('about-text')){
                $el.find(suitabilityTextAmountInput).each((idx,matrix)=>{
                    const investmentInput = $(matrix).parent().removeClass('d-none').detach();
                    const amountText = $el.find(suitabilityAmountRupee);
                    if(idx == 0){
                        termInsuranePlaceholderText = '{martialStatus}';
                    }else{
                        termInsuranePlaceholderText = ' {age}';
                    }
                    if(suitabilityAmountRupee.length > 0){
                        const replacedTextEl = amountText.html().replace(termInsuranePlaceholderText, investmentInput.prop('outerHTML'));
                        amountText.html(replacedTextEl);
                        calculators.methods.currencyFormat();
                        calculators.methods.onlyNumbers();
                        calculators.methods.onlyText();
                    }
                });
            }else{
                const investmentInput = $el.find(suitabilityTextAmountInput).parent().removeClass('d-none').detach();
                const amountText = $el.find(suitabilityAmountRupee);
                if(suitabilityAmountRupee.length > 0){
                    const replacedTextEl = amountText.html().replace(termInsuranePlaceholderText, investmentInput.prop('outerHTML'));
                    amountText.html(replacedTextEl);
                    calculators.methods.currencyFormat();
                    calculators.methods.onlyNumbers();
                    calculators.methods.onlyText();
                }
            }
        },
        handlesuitability : (el)=>{
            const $el = $(el);
            const goalValue = $el.find('.investmentGoal__select').val();
            $el.find('.suitability__component').find('.suitability__component--top').addClass('d-none');
            $el.find('.suitability__component').find('div').each((idx,plans)=>{
                if($(plans).hasClass(goalValue)){
                    $(plans).find('h2').addClass('d-none');
                    $(plans).find('.primary-bar').addClass('d-none');
                    $(plans).find('.fix-width-description').addClass('d-none');
                    $(plans).removeClass('d-none');
                }
            });
        },
        requiredValidationOnInput:function(el){
            const $el = $(el);
            $el.find("input").on(CONSTANT.eventsListners.INPUT,function(e){
                if($(this).hasClass('suitability--input-contact')){
                    const mobileValue = $(this).val();
                    if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                        e.target.value = mobileValue.slice(0, -1);
                    }
                }
            });
        },
        validateAllInputFields : ($el, inputs)=>{
            if(inputs.hasClass('suitability--input-contact')){
                const $field = $el.find('.suitability--input-contact');
                if($field.val() && !suitability.methods.validatePhoneNumber($field.val())){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Phone Number is not Correct</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
        },
        validatePhoneNumber : (value)=>{
            value = value.replace(/[^0-9]/g, '');
            if (value.length === 10 && /^[6789]\d{9}$/.test(value)) {
                return true;
            } else {
                return false;
            }
        },
        handlePrevNext : (el)=>{
            const $el = $(el);
            const { suitabilityNextButton ,suitabilityPrevButton , suitabilityFormSubmit,suitabilityAnwers } = suitability.variables;
            $el.find(suitabilityFormSubmit).on(CONSTANT.eventsListners.SUBMIT,function(e){
                e.preventDefault();
                calculators.methods.validateRequiredFields();
                suitability.methods.validateAllInputFields($el,$el.find("input"));
                const isError = $el.find('.suitability__forms--details-1.active').find('.error__active');
                if(isError.length) {return;}
                const isBack = calculators.methods.handleNextPrev(el,false);
                if(isBack){
                    $el.find(suitabilityPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(suitabilityPrevButton).addClass('d-none');
                    $el.find(suitabilityNextButton).addClass('d-none');
                    $el.find(suitabilityAnwers).removeClass('d-none');
                    suitability.methods.handlesuitability(el);
                }
            });
            $el.find(suitabilityPrevButton).on(CONSTANT.eventsListners.CLICK,function(){
                const isBack = calculators.methods.handleNextPrev(el,true);
                if(isBack){
                    $el.find(suitabilityPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(suitabilityPrevButton).addClass('d-none');
                }
            });
        },
        handleAllInputs:(el)=>{
            const $el = $(el);
            $el.find(suitability.variables.suitabilityTextAmountDetails).each((idx,details)=>{
                suitability.methods.replaceAmountInput(details);
            });
            $el.find(suitability.variables.suitabilityTextAnswersButton).on(CONSTANT.eventsListners.CLICK,(e)=>{
                $el.find(suitability.variables.suitabilityAnwers).addClass('d-none');
                $($el.find(suitability.variables.suitabilityDetails)[0]).addClass('active');
                $el.find(suitability.variables.suitabilityStep).removeClass('active');
                $($el.find(suitability.variables.suitabilityStep)[0]).addClass('active');
                $el.find(suitability.variables.suitabilityNextButton).removeClass('d-none');
                $el.find(suitability.methods.suitabilityMobileSteps).find('.suitability__step-text').removeClass('active');
                $($el.find(suitability.methods.suitabilityMobileSteps).find('.suitability__step-text')[0]).removeClass('active');
            });
        },
        handleButtonClickEvent :(el)=>{
            $(el).find('.suitability__buttons--next.chli_btn--primary').on('click', function(e){

                let calculatorSection=$(this).closest('.suitabilityCalculator').find('.suitability__wrapper--step.active').find('.suitability__step-text').text();
                let calculatorName=$(this).closest('.suitabilityCalculator').find('.suitability__wrapper--title').text();
                let container = $(this).closest('.suitabilityCalculator').find('.suitability__wrapper--step.active');
                let age = null;
                let name = null;
                let mobileNumber = null;
                if(container && container.data('page') == 2){
                 age = container.closest('.suitability__wrapper.chli__calculator--container').find('.suitability__input-div').find('select[name="age"]').val();
                }
                if(container && container.data('page') == 3){
                  name = container.closest('.suitability__wrapper.chli__calculator--container').find('.suitability__input-div').find('input[name="name"]').val();
                  mobileNumber = container.closest('.suitability__wrapper.chli__calculator--container').find('.suitability__input-div').find('input[name="contact"]').val();
                }
                var obj = suitability.methods.dataLayerObj(e,calculatorName,calculatorSection,name,mobileNumber,age);
                createDataLayer('buttonClick', obj);
            });
            $(el).find('.suitability__buttons--prev').on('click', function(e){
              let calculatorSection=$(this).closest('.suitabilityCalculator').find('.suitability__wrapper--step.active').find('.suitability__step-text').text();
              let calculatorName=$(this).closest('.suitabilityCalculator').find('.suitability__wrapper--title').text();
              var obj = suitability.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });
        },
         dataLayerObj: function (e,name,section,el,mobileNumber,age) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection' : name.replace(/\n/g, '').trim().concat('_').concat(section).replace(/\n/g, '').trim(),
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'age' : age ? age : "",
                'name' : el ? el : "",
                'mobileNumber' : mobileNumber ? mobileNumber : "",
                'bannerName' : "",
                "countryCode" : "+91",
            };
            return obj;
        },
        init : ()=>{
            if($('.suitability').length > 0){
                $('.suitability').each((idx,ele)=>{
                    suitability.methods.handlePrevNext(ele);
                    suitability.methods.handleAllInputs(ele);
                    suitability.methods.requiredValidationOnInput(ele);
                    suitability.methods.handleButtonClickEvent(ele);
                });
            }
        }
    }
};
$(()=>{
    suitability.methods.init();
});
